/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseLinkGallerySearchEngine } from './DatabaseLinkGallerySearchEngine';
import {
    DatabaseLinkGallerySearchEngineFromJSON,
    DatabaseLinkGallerySearchEngineFromJSONTyped,
    DatabaseLinkGallerySearchEngineToJSON,
} from './DatabaseLinkGallerySearchEngine';

/**
 * 
 * @export
 * @interface DatabaseLinkGalleryPage
 */
export interface DatabaseLinkGalleryPage {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseLinkGalleryPage
     */
    enabled?: boolean;
    /**
     * Alias (subUri) der Datenbank, aus der die Kacheln kommen — der Teil
     * hinter datenbankgestalter.de/. LEER = die eigene Datenbank.
     * Eine fremde Quelle liefert nur, wenn sie anonym ohne Kennwort offen
     * ist und ein Leserecht traegt; das entscheidet ihre Rechte-Maske.
     * @type {string}
     * @memberof DatabaseLinkGalleryPage
     */
    sourceAlias?: string;
    /**
     * Feld-Id der Kategorie in der Quelle. Leer = keine Kategorienleiste.
     * @type {string}
     * @memberof DatabaseLinkGalleryPage
     */
    categoryFieldId?: string;
    /**
     * Feld-Id der Abbildung in der Quelle. Leer = Kachel ohne Bild.
     * @type {string}
     * @memberof DatabaseLinkGalleryPage
     */
    imageFieldId?: string;
    /**
     * Feld-Id des Links in der Quelle. Pflicht.
     * @type {string}
     * @memberof DatabaseLinkGalleryPage
     */
    linkFieldId?: string;
    /**
     * Feld-Id der Beschreibung in der Quelle. Pflicht.
     * @type {string}
     * @memberof DatabaseLinkGalleryPage
     */
    captionFieldId?: string;
    /**
     * 
     * @type {DatabaseLinkGallerySearchEngine}
     * @memberof DatabaseLinkGalleryPage
     */
    searchEngine?: DatabaseLinkGallerySearchEngine;
}

/**
 * Check if a given object implements the DatabaseLinkGalleryPage interface.
 */
export function instanceOfDatabaseLinkGalleryPage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseLinkGalleryPageFromJSON(json: any): DatabaseLinkGalleryPage {
    return DatabaseLinkGalleryPageFromJSONTyped(json, false);
}

export function DatabaseLinkGalleryPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseLinkGalleryPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'sourceAlias': !exists(json, 'sourceAlias') ? undefined : json['sourceAlias'],
        'categoryFieldId': !exists(json, 'categoryFieldId') ? undefined : json['categoryFieldId'],
        'imageFieldId': !exists(json, 'imageFieldId') ? undefined : json['imageFieldId'],
        'linkFieldId': !exists(json, 'linkFieldId') ? undefined : json['linkFieldId'],
        'captionFieldId': !exists(json, 'captionFieldId') ? undefined : json['captionFieldId'],
        'searchEngine': !exists(json, 'searchEngine') ? undefined : DatabaseLinkGallerySearchEngineFromJSON(json['searchEngine']),
    };
}

export function DatabaseLinkGalleryPageToJSON(value?: DatabaseLinkGalleryPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'sourceAlias': value.sourceAlias,
        'categoryFieldId': value.categoryFieldId,
        'imageFieldId': value.imageFieldId,
        'linkFieldId': value.linkFieldId,
        'captionFieldId': value.captionFieldId,
        'searchEngine': DatabaseLinkGallerySearchEngineToJSON(value.searchEngine),
    };
}

